<template>
  <div
    class="spinner-container"
    :style="{top: offsetTop}"
  >
    <font-awesome-icon
      icon="spinner"
      :size="size"
      spin
      :color="color"
    />
    <!-- <i class="fa fa-spinner fa-spin" /> -->
  </div>
</template>

<script>
export default {

  name: 'Spinner',
  props: {
    offsetTop: {
      type: String,
      default: '0'
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '2x'
    }
  }
}
</script>

<style lang="css" scoped>
  .spinner-container {
    /*width: 100%;*/
    /*height: 100%;*/
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    display: flex;
    align-items: center;
    justify-content: center;
    /*padding: 50px;*/
  }
  i {
    font-size: 4em;
  }
</style>
